$(document).ready(function() {
    setTimeout(function() {
        $(".product-detail-quantity-buy-button .buy-buttons .button").css("pointer-events", "auto");
    }, 200);

if($(".variant-picker__option-values .sr-only").length){  
 $(function () {
    var chkItem=$(".variant-picker__option-values .sr-only");
      $(".shopify-payment-button__button").click(function (e) {
          var isValid = false;
            
            if($(chkItem).is(":checked") || isValid){
            }
            else{
              $(".error-message").css("display", "block");
              e.preventDefault();
              return false;
            }
      });
    $(document).on('change', '.variant-picker__option-values .sr-only', function() {
        $('#select_size_error-message').html("");
        $(".error-message").css("display", "none");
      $(".variant-inventory-stock span").css("display", "block");
      });
  }); 
}

if($(".variant-picker__option-values .sr-only").length){
 $(function () {
    var chkItem=$(".variant-picker__option-values .sr-only");
      $(".buy-buttons .button").click(function (e) {
          var isValid = false;
            
            if($(chkItem).is(":checked") || isValid){
            }
            else{
              $(".error-message").css("display", "block");
              e.preventDefault();
              return false;
            }
      });
    $(document).on('change', '.variant-picker__option-values .sr-only', function() {
        $('#select_size_error-message').html("");
        $(".error-message").css("display", "none");
      });
  }); 
}

var quick_but_modal = $(".quick-buy-modal__info-wrapper .product-info__block-item .buy-buttons .button").length
if(quick_but_modal === 0){
     setTimeout(function() {
        $(".quick-buy-modal__info-wrapper .product-detail-quantity-buy-button .buy-buttons .button").css("pointer-events", "auto");
    }, 200);
    if($(".variant-picker__option-values .sr-only").length){
        $(function () {
            var chkItem=$(".variant-picker__option-values .sr-only");
            $(".buy-buttons .button").click(function (e) {
                var isValid = false;
                    
                    if($(chkItem).is(":checked") || isValid){
                    }
                    else{
                    $(".error-message").css("display", "block");
                    // $('html, body').animate({scrollTop: '0px'}, 1500);
                    e.preventDefault();
                    return false;
                    }
            });
            $(document).on('change', '.variant-picker__option-values .sr-only', function() {
                $('#select_size_error-message').html("");
                $(".error-message").css("display", "none");
            });
        }); 
    }
}else{

}
});